import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Vector = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="vector icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M2.5 5C3.88071 5 5 3.88071 5 2.5C5 1.11929 3.88071 0 2.5 0C1.11929 0 0 1.11929 0 2.5C0 3.88071 1.11929 5 2.5 5Z"
    />
    <path
      className={pathClass}
      d="M13.5 2.5C13.5 3.88071 12.3807 5 11 5C9.61929 5 8.5 3.88071 8.5 2.5C8.5 1.11929 9.61929 0 11 0C12.3807 0 13.5 1.11929 13.5 2.5Z"
    />
    <path
      className={pathClass}
      d="M22 2.5C22 3.88071 20.8807 5 19.5 5C18.1193 5 17 3.88071 17 2.5C17 1.11929 18.1193 0 19.5 0C20.8807 0 22 1.11929 22 2.5Z"
    />
    <path
      className={pathClass}
      d="M2.5 13.5C3.88071 13.5 5 12.3807 5 11C5 9.61929 3.88071 8.5 2.5 8.5C1.11929 8.5 0 9.61929 0 11C0 12.3807 1.11929 13.5 2.5 13.5Z"
    />
    <path
      className={pathClass}
      d="M13.5 11C13.5 12.3807 12.3807 13.5 11 13.5C9.61929 13.5 8.5 12.3807 8.5 11C8.5 9.61929 9.61929 8.5 11 8.5C12.3807 8.5 13.5 9.61929 13.5 11Z"
    />
    <path
      className={pathClass}
      d="M22 11C22 12.3807 20.8807 13.5 19.5 13.5C18.1193 13.5 17 12.3807 17 11C17 9.61929 18.1193 8.5 19.5 8.5C20.8807 8.5 22 9.61929 22 11Z"
    />
    <path
      className={pathClass}
      d="M2.5 22C3.88071 22 5 20.8807 5 19.5C5 18.1193 3.88071 17 2.5 17C1.11929 17 0 18.1193 0 19.5C0 20.8807 1.11929 22 2.5 22Z"
    />
    <path
      className={pathClass}
      d="M13.5 19.5C13.5 20.8807 12.3807 22 11 22C9.61929 22 8.5 20.8807 8.5 19.5C8.5 18.1193 9.61929 17 11 17C12.3807 17 13.5 18.1193 13.5 19.5Z"
    />
    <path
      className={pathClass}
      d="M22 19.5C22 20.8807 20.8807 22 19.5 22C18.1193 22 17 20.8807 17 19.5C17 18.1193 18.1193 17 19.5 17C20.8807 17 22 18.1193 22 19.5Z"
    />
  </svg>
)
